export enum StatusReserva {
  REQUESTED = 0,
  ACCEPTED = 1,
  FINISHED = 2,
  CANCELLED = 3,
  DECLINED = 4,
  NO_SHOW = 5,
}

export enum StatusCorrida {
  PENDING = 0,
  ACCEPTED = 1,
  STARTED = 2,
  FINISHED = 3,
  CANCELLED = 4,
  DISPUTED = 5,
}

export enum StatusCorridaFilter {
  PENDING = "PENDENTE",
  ACCEPTED = "ACEITA",
  STARTED = "INICIADA",
  FINISHED = "FINALIZADA",
  CANCELLED = "CANCELADA",
}

export enum StatusReservaFilter {
  REQUESTED = "SOLICITADA",
  ACCEPTED = "ACEITA",
  FINISHED = "FINALIZADA",
  CANCELLED = "CANCELADA",
  DECLINED = "RECUSADA",
  NO_SHOW = "NAO_COMPARECEU",
}

// PENDING = "PENDING",
// ACCEPTED = "ACCEPTED",
// STARTED = "STARTED",
// FINISHED = "FINISHED",
// CANCELLED = "CANCELLED",
